import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'

import FormButton from '@/components/common/FormButton.vue'
import FormButtonGroup from '@/components/common/FormButtonGroup.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import { useAuthStore } from '@/store/bowler-app/auth'
import { AuthPayload } from '@/store/bowler-app/auth.types'
import { getErrorMessage } from '@/utils/error-handling'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const router = useRouter()

/* local state */

const formData = ref<AuthPayload>({ email: '', password: '' })
const formError = ref<string | null>()
const isLoading = ref<boolean>(false)

/* actions */

const submit = async (): Promise<void> => {
  isLoading.value = true
  formError.value = null

  try {
    await useAuthStore().login(formData.value)
    await router.push({ path: '/' })
  } catch (e) {
    formError.value = getErrorMessage(e as Error)
    console.group('Login failed')
    console.error(formError.value)
    console.groupEnd()
  }

  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("form", {
    class: "login-form",
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    (formError.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 0,
          "is-danger": "",
          message: formError.value
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(FormTextInput, {
      modelValue: formData.value.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
      name: "email",
      type: "email",
      label: _ctx.$t('field-labels.email'),
      "is-disabled": isLoading.value,
      autocomplete: "on",
      "is-required": ""
    }, null, 8, ["modelValue", "label", "is-disabled"]),
    _createVNode(FormTextInput, {
      modelValue: formData.value.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
      name: "password",
      type: "password",
      label: _ctx.$t('field-labels.password'),
      "is-disabled": isLoading.value,
      autocomplete: "on",
      "is-required": ""
    }, null, 8, ["modelValue", "label", "is-disabled"]),
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('general.forgotten-password')), 1),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_RouterLink, { to: { path: '/password-reset' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('general.password-reset')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(FormButtonGroup, null, {
      default: _withCtx(() => [
        _createVNode(FormButton, { "is-busy": isLoading.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.login')), 1)
          ]),
          _: 1
        }, 8, ["is-busy"]),
        _withDirectives(_createVNode(RouterLinkButton, { to: { path: '/register' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('bowler-registration.heading')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, !isLoading.value]
        ])
      ]),
      _: 1
    })
  ], 32))
}
}

})